var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 3.33454V26.0148C17.75 26.0924 17.714 26.1656 17.6525 26.2129L8.57775 33.1957C8.47714 33.2731 8.36717 33.2628 8.28003 33.1957C8.1907 33.127 8.13629 33.0038 8.18035 32.8602L11.606 21.694C11.7039 21.3749 11.599 21.0201 11.3332 20.8156L2.36476 13.9145C2.25888 13.833 2.22734 13.702 2.26508 13.579C2.3026 13.4567 2.39508 13.3805 2.51362 13.3805L13.5993 13.3805C13.9391 13.3805 14.2273 13.1496 14.3258 12.8286L17.261 3.26121C17.3452 2.98676 17.75 3.04746 17.75 3.33454Z",
    stroke: "var(--icon-color)",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.19333bb5515bf4f2464746d56b208ec1.svg";
export { ForwardRef as ReactComponent };